import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { ContactNamePipe } from '@app/shared/pipes/contact-name.pipe';
import { PhoneNumberPipe } from '@app/shared/pipes/phone-number.pipe';
import { EndUserContextService } from '@app/shared/services/context/end-user-context.service';
import { TypeaheadBasketService } from '@app/shared/services/typeahead-basket.service';
import { StringMap } from '@app/utils/string-map';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TypeaheadBasketServiceFactory {
  public instances: StringMap<TypeaheadBasketService> = {};

  constructor(
    private authenticationService: AuthenticationService,
    private contactNamePipe: ContactNamePipe,
    private endUserContextService: EndUserContextService,
    private phoneNumberPipe: PhoneNumberPipe,
    private translateService: TranslateService
  ) {}

  /**
   * Teardown the instance of the given key
   * @param key
   */
  public destroy(key: string = 'GLOBAL') {
    if (this.instances[key] !== undefined) {
      // Clear
      this.instances[key].clear();

      // Release
      delete this.instances[key];
    }
  }

  /**
   * Get the TypeaheadBasketService that is associated with the given key.
   * Creates a new service if it doesn't exist.
   * @param key
   */
  public get(key: string = 'GLOBAL') {
    if (this.instances[key] === undefined) {
      // Create a new instance if none exists for the given key
      this.instances[key] = new TypeaheadBasketService(
        this.authenticationService,
        this.contactNamePipe,
        this.endUserContextService,
        this.phoneNumberPipe,
        this.translateService
      );
    }

    return this.instances[key];
  }
}
